<template>
    <div id="index" class="index">
        <!-- logo && 诗 -->
        <div class="index-row">
            <div class="poetry">
                <div>
                    <span
                        :class="['left', {'animated':!isMobile, 'fadeInLeft':!isMobile, 'delay-3s':!isMobile}]"
                    ></span>
                    <span
                        :class="['mid', {'animated':!isMobile, 'fadeInLeft':!isMobile, 'delay-2s':!isMobile}]"
                    ></span>
                    <span
                        :class="['right', {'animated':!isMobile, 'fadeInLeft':!isMobile, 'delay-1s':!isMobile}]"
                    ></span>
                </div>
                <img src="@assets/imgs/index-poetry.png" alt="poetry" />
            </div>
            <div :class="['logo', {'animated':!isMobile, 'bounceInLeft':!isMobile}]">
                <img src="@assets/imgs/logo-cn.png?v=1" />

            </div>
        </div>
        <!-- 中间横幅文字 -->
        <div class="index-row">
            <div :class="['slogan', {'animated':!isMobile, 'bounceInLeft':!isMobile}]">
                <img src="@assets/imgs/index-slogan-cn.png" />
            </div>
        </div>
        <!-- 下载 -->
        <div class="index-row">
            <div :class="['channel', {'animated':!isMobile, 'bounceInLeft':!isMobile}]">
                <div class="text">{{$t("index.channel_text")}}</div>
                <div class="btn-down-group">
                    <a class="btn-down-appstore" href="https://apps.apple.com/cn/app/%E4%B9%9D%E5%B7%9E%E9%9C%B8%E4%B8%9A-%E5%B9%95%E5%BA%9C/id1593366824" target="_blank"></a>
                    <a class="btn-down-google" href="https://download.bekko.com/apkstore/CN-p20n/jzby.apk" target="_blank"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    components: {},
    created() {},
    mounted() {},
    methods: {
        download_appstore() {
            alert("appstore");
        },
        download_google() {
            alert("google");
        }
    }
};
</script>

<style lang="scss">
.index {
    width: 100%;
    height: 100%;
    min-height: 800px;
    position: relative;
    padding-top: 70px;
    .index-row {
        width: 100%;
        display: flex;
        justify-content: center;
        .logo {
            width: 30%;
            min-width: 400px;
            margin-top: 100px;
        }
        .slogan {
            width: 60%;
            min-width: 700px;
            margin-top: 10px;
        }
        .channel {
            width: 50%;
            min-width: 700px;
            height: 160px;
            margin-top: 80px;
            background: url("~@assets/imgs/index-channel.png") center center
                no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 0 5%;
            .text {
                width: 40%;
                height: 60px;
                line-height: 60px;
                font-size: 36px;
                font-weight: bold;
                color: #441307;
                text-align: center;
            }
            .btn-down-group {
                height: 60px;
                width: 65%;
                display: flex;
                justify-content: space-around;
                a {
                    display: flex;
                    align-items: center;
                    width: 195px;
                    height: 100%;
                    background: url("~@assets/imgs/btn-download.png")
                        no-repeat;
                    background-size: auto 100%;
                }
                .btn-down-appstore {
                    background-position: 0 0;
                }
                .btn-down-google {
                    background-position: -214px 0;
                }
            }
        }
        .logo img,
        .slogan img,
        .channel img {
            width: 100%;
        }
        .poetry {
            position: absolute;
            left: 7%;
            top: 200px;
            width: 15%;
            div {
                position: absolute;
                width: 100%;
                height: 100%;
                display: flex;
                span {
                    display: block;
                    width: 33.33%;
                    height: 100%;
                    background: url("~@assets/imgs/index-poetry.png")
                        no-repeat;
                    background-size: auto 100%;
                }
                .left {
                    background-position: 0 0;
                }
                .mid {
                    background-position: 45% 0;
                }
                .right {
                    background-position: 100% 0;
                }
            }

            img {
                width: 100%;
                opacity: 0;
                z-index: -10;
            }
        }
    }
}
@media screen and (max-width: 1600px) {
    .index {
        .index-row {
            .channel {
                .text {
                    height: 50px;
                    line-height: 50px;
                    font-size: 26px;
                }
                .btn-down-group {
                    height: 50px;
                    a {
                        width: 162px;
                    }
                    .btn-down-google {
                        background-position: -179px 0;
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 1440px) {
    .index {
        .index-row {
            .channel {
                .text {
                    width: 30%;
                }
            }
        }
    }
}
// 移动端
@media screen and (max-width: 768px) {
    .index {
        height: auto;
        min-height: 300px;
        padding: 50px 0;
        background: url("~@assets/imgs/bgphone-top-p20n.jpg") center center
            no-repeat;
        background-size: 100%;
        .index-row {
            .logo {
                width: 500px;
                min-width: 200px;
                margin-top: 20px;
            }
            .slogan {
                width: 600px;
                min-width: 200px;
            }
            .channel {
                margin-top: 50px;
                width: 600px;
                min-width: 200px;
                height: 100px;
                padding: 0 10%;
                .text {
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                }
                .btn-down-group {
                    height: 40px;
                    a {
                        width: 130px;
                    }
                    .btn-down-google {
                        background-position: -143px 0;
                    }
                }
            }
            .poetry {
                display: none;
            }
        }
    }
}
@media screen and (max-width: 500px) {
    .index {
        padding: 30px 0;
        .index-row {
            .logo {
                width: 200px;
            }
            .slogan {
                width: 300px;
            }
            .channel {
                margin-top: 50px;
                width: 350px;
                height: 60px;
                padding: 0 30px;
                .text {
                    font-size: 12px;
                    width: 120px;
                }
                .btn-down-group {
                    height: 25px;
                    a {
                        width: 81px;
                    }
                    .btn-down-google {
                        background-position: -89px 0;
                    }
                }
            }
            .poetry {
                display: none;
            }
        }
    }
}
@media screen and (max-width: 375px) {
    .index {
        padding: 20px 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue